export function resampleTo16kHz(samples: Float32Array, fromSampleRate: number): Float32Array {
    if (fromSampleRate === 16000) return samples;
    const ratio = fromSampleRate / 16000;
    const outputLength = Math.round(samples.length / ratio);
    const output = new Float32Array(outputLength);
    for (let i = 0; i < outputLength; i++) {
        output[i] = samples[Math.floor(i * ratio)];
    }
    return output;
}

export function resampleTo(samples: Float32Array, fromSampleRate: number, toSampleRate: number): Float32Array {
    if (fromSampleRate === toSampleRate) return samples;
    const ratio = fromSampleRate / toSampleRate;
    const outputLength = Math.round(samples.length / ratio);
    const output = new Float32Array(outputLength);
    for (let i = 0; i < outputLength; i++) {
        output[i] = samples[Math.floor(i * ratio)];
    }
    return output;
}

function linearToMulaw(sample: number): number {
    const BIAS = 0x84;
    const CLIP = 32635;
    let sign = 0;
    if (sample < 0) { sign = 0x80; sample = -sample; }
    if (sample > CLIP) sample = CLIP;
    sample += BIAS;
    let exponent = 7;
    for (let i = 0x4000; (sample & i) === 0 && exponent > 0; i >>= 1, exponent--) { /* scan */ }
    return ~(sign | (exponent << 4) | ((sample >> (exponent + 3)) & 0x0F)) & 0xFF;
}

// Encodes Float32 at any sample rate to G.711 mulaw at 8kHz
export function float32ToMulaw8k(float32: Float32Array, fromSampleRate: number): Uint8Array {
    const resampled = fromSampleRate !== 8000 ? resampleTo(float32, fromSampleRate, 8000) : float32;
    const output = new Uint8Array(resampled.length);
    for (let i = 0; i < resampled.length; i++) {
        const s = Math.max(-1, Math.min(1, resampled[i]));
        output[i] = linearToMulaw(Math.round(s < 0 ? s * 0x8000 : s * 0x7FFF));
    }
    return output;
}

export function uint8ToBase64(buffer: Uint8Array): string {
    let binary = "";
    const chunkSize = 0x8000;
    for (let i = 0; i < buffer.length; i += chunkSize) {
        binary += String.fromCharCode(...buffer.subarray(i, i + chunkSize));
    }
    return btoa(binary);
}

export function float32ToPCM16(float32: Float32Array): ArrayBuffer {
    const buffer = new ArrayBuffer(float32.length * 2);
    const view = new DataView(buffer);

    for (let i = 0; i < float32.length; i++) {
        const s = Math.max(-1, Math.min(1, float32[i]));
        view.setInt16(
            i * 2,
            s < 0 ? s * 0x8000 : s * 0x7fff,
            true
        );
    }

    return buffer;
}

export function pcm16ToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    const chunkSize = 0x8000;

    for (let i = 0; i < bytes.length; i += chunkSize) {
        binary += String.fromCharCode(
            ...bytes.subarray(i, i + chunkSize)
        );
    }

    return btoa(binary);
}
